import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';
import { TipoArquivoSituacao } from '../situacao';

/** Representa o Filter da pesquisa dos tipos de arquivos */
export class TipoArquivoFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    situacoes: number[] = [];
    referencias: number[] = [];

    constructor() {
        this.setDefaults();
    }

    private setDefaults() {
        //
    }

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Situações
        if (this.situacoes && this.situacoes.length > 0) {
            const hasAtivo = this.situacoes.includes(TipoArquivoSituacao.ATIVO);
            const hasInativo = this.situacoes.includes(TipoArquivoSituacao.INATIVO);
            if (hasAtivo && hasInativo) { // Ambos
                params = params.delete('ativo');
            } else if (hasAtivo) { // Ativo
                params = params.append('ativo', 'true');
            } else { // Inativo
                params = params.append('ativo', 'false');
            }
        }

        // Referências
        this.referencias?.forEach(referencia => params = params.append('referencia', referencia.toString()))

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.situacoes = [];
        this.referencias = [];

        this.setDefaults();
    }
}

